<p-toast position="top-center" key="register"></p-toast>
<div class="register-container bg-light">
  <div class="register-box" style="background-image: url('../../../assets/images/slider-video-2.avif')">
    <div class="pt-4">
      <div class="d-inline-block ml-3">
        <app-language-selector></app-language-selector>
      </div>
    </div>
    <h3 translate>Register Now</h3>
    <p class="text-center">{{ 'FillRegForm' | translate }}</p>
    <div class="container">
      <div class="card col-md-5 mx-auto">
        <div class="card-body pt-0 pb-0">
          <h4 class="card-title text-center mb-2">
            <!-- <i class="far fa-3x fa-user-circle text-muted"></i> -->
            <img class="img-fluid" src="../../assets/images/logo.png" />
          </h4>
          <form (ngSubmit)="onSubmit()" [formGroup]="registerForm" novalidate>
            <div class="#">
              <label for="mail" class="d-block">
                <b>{{ 'Email ID' | translate }}</b
                ><i class="text-danger" aria-hidden="true">*</i></label
              >
              <input
                type="text"
                formControlName="mail"
                class="form-control"
                placeholder="{{ 'Enter Email' | translate }}"
                name="mail"
                id="mail"
                required
              />
              <div
                *ngIf="
                  (registerForm.controls['mail'].invalid && registerForm.controls['mail'].touched) ||
                  registerForm.controls['mail'].dirty
                "
              >
                <small *ngIf="registerForm.controls['mail'].errors?.required" class="text-danger">{{
                  'Require Email' | translate
                }}</small>
                <small *ngIf="registerForm.controls['mail'].errors?.pattern" class="text-danger">{{
                  'Valid Email' | translate
                }}</small>
              </div>
            </div>
            <div class="margin-top">
              <label for="name" class="d-block"
                ><b>{{ 'User Name' | translate }}</b
                ><i class="text-danger" aria-hidden="true">*</i></label
              >
              <input
                type="text"
                formControlName="name"
                class="form-control"
                placeholder="{{ 'Enter username' | translate }}"
                name="name"
                id="name"
                required
                maxlength="15"
              />

              <small
                [hidden]="registerForm.controls.name.valid || registerForm.controls.name.untouched"
                class="text-danger"
                translate
              >
                {{ 'Require Username' | translate }}
              </small>
            </div>
            <div class="margin-top">
              <label for="pass"
                ><b>{{ 'Password' | translate }}</b
                ><i class="text-danger" aria-hidden="true">*</i></label
              >
              <label class="d-block">
                <input
                  [type]="fieldPasswordType ? 'text' : 'password'"
                  formControlName="pass"
                  class="form-control"
                  placeholder="{{ 'Enter password' | translate }}"
                  name="pass"
                  id="pass"
                  maxlength="30"
                  pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,15}$"
                  required
                />
                <i
                  class="fa passwordShow"
                  [ngClass]="{
                    'fa-eye-slash': !fieldPasswordType,
                    'fa-eye': fieldPasswordType
                  }"
                  (click)="togglePasswordType()"
                ></i>
                <span
                  *ngIf="
                    !registerForm.controls['pass'].valid &&
                    (registerForm.controls['pass'].dirty || registerForm.controls['pass'].touched)
                  "
                >
                  <small class="text-danger" *ngIf="registerForm.controls['pass'].errors?.required">{{
                    'Require Password' | translate
                  }}</small>
                  <small class="text-danger" *ngIf="registerForm.controls['pass'].errors?.pattern">{{
                    'Valid Password' | translate
                  }}</small>
                </span>
              </label>
            </div>
            <div class="margin-top">
              <label for="confirm_pass"
                ><b>{{ 'Confirm Password' | translate }}</b
                ><i class="text-danger" aria-hidden="true">*</i></label
              >
              <label class="d-block">
                <input
                  [type]="fieldConfirmPasswordType ? 'text' : 'password'"
                  class="form-control"
                  placeholder="{{ 'Enter Confirm password' | translate }}"
                  name="confirm_pass"
                  id="confirm_pass"
                  formControlName="confirm_pass"
                  maxlength="30"
                  required
                />
                <i
                  class="fa passwordShow"
                  [ngClass]="{
                    'fa-eye-slash': !fieldConfirmPasswordType,
                    'fa-eye': fieldConfirmPasswordType
                  }"
                  (click)="toggleConfirmPasswordType()"
                ></i>
                <span
                  class="text-danger"
                  *ngIf="
                    !registerForm.controls['confirm_pass'].valid &&
                    (registerForm.controls['confirm_pass'].dirty || registerForm.controls['confirm_pass'].touched)
                  "
                >
                  <small *ngIf="registerForm.controls['confirm_pass'].errors?.required">
                    {{ 'Require Confirm Password' | translate }}</small
                  >
                </span>
                <span
                  class="text-danger"
                  *ngIf="
                    registerForm.controls['confirm_pass'].valid &&
                    (registerForm.controls['confirm_pass'].dirty || registerForm.controls['confirm_pass'].touched)
                  "
                >
                  <small *ngIf="registerForm.controls['pass'].value != registerForm.controls['confirm_pass'].value">{{
                    'Passwords Match' | translate
                  }}</small>
                </span>
              </label>
            </div>

            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" formControlName="subscribe" />
                <span>{{ 'Registration Subscribe' | translate }}</span>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input type="radio" value="true" class="form-check-input" formControlName="agreed" />
                <span
                  >{{ 'PrivacyPolicy' | translate }}
                  <a routerLink="/privacy_policy">{{ 'PrivacyPolicyLink' | translate }}</a>
                  {{ 'PrivacyPolicyReg' | translate }}<i class="text-danger" aria-hidden="true">*</i></span
                >
                <small
                  [hidden]="registerForm.controls.agreed.valid || registerForm.controls.agreed.untouched"
                  class="text-danger"
                  translate
                >
                  {{ 'Require PrivacyPolicy' | translate }}
                </small>
              </label>
            </div>
            <button class="btn btn-primary w-100 margin-top" type="submit" [disabled]="registerForm.invalid">
              <span>{{ 'Register' | translate }}</span>
            </button>
          </form>
          <div class="signin">
            <p class="mb-0">
              {{ 'AlreadyHaveAccount' | translate }}?
              <a routerLink="/login" class="btn btn-link">{{ 'Login' | translate }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
